export class IngestionPipelineMetrics {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "observedAt",
            "baseName": "observedAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "sourceRecordsPerSec",
            "baseName": "sourceRecordsPerSec",
            "type": "number",
            "format": ""
        },
        {
            "name": "sinkRecordsPerSec",
            "baseName": "sinkRecordsPerSec",
            "type": "number",
            "format": ""
        },
        {
            "name": "sourceBytesPerSec",
            "baseName": "sourceBytesPerSec",
            "type": "number",
            "format": ""
        },
        {
            "name": "sourceTotalRecordsRead",
            "baseName": "sourceTotalRecordsRead",
            "type": "number",
            "format": ""
        },
        {
            "name": "sinkTotalRecordsWritten",
            "baseName": "sinkTotalRecordsWritten",
            "type": "number",
            "format": ""
        },
        {
            "name": "sourceBacklogRecords",
            "baseName": "sourceBacklogRecords",
            "type": "number",
            "format": ""
        },
        {
            "name": "sourceFilesPending",
            "baseName": "sourceFilesPending",
            "type": "number",
            "format": ""
        },
        {
            "name": "sourceOldestPendingAgeSeconds",
            "baseName": "sourceOldestPendingAgeSeconds",
            "type": "number",
            "format": ""
        },
        {
            "name": "dlqMessages",
            "baseName": "dlqMessages",
            "type": "number",
            "format": ""
        },
        {
            "name": "invalidRecordsPerSec",
            "baseName": "invalidRecordsPerSec",
            "type": "number",
            "format": ""
        },
        {
            "name": "errorRate1hPct",
            "baseName": "errorRate1hPct",
            "type": "number",
            "format": ""
        },
        {
            "name": "secondsSinceLastCommit",
            "baseName": "secondsSinceLastCommit",
            "type": "number",
            "format": ""
        },
        {
            "name": "completedCheckpointsTotal",
            "baseName": "completedCheckpointsTotal",
            "type": "number",
            "format": ""
        },
        {
            "name": "lagSeconds",
            "baseName": "lagSeconds",
            "type": "number",
            "format": ""
        },
        {
            "name": "jvmHeapUsedBytesMax",
            "baseName": "jvmHeapUsedBytesMax",
            "type": "number",
            "format": ""
        },
        {
            "name": "jvmHeapMaxBytesMax",
            "baseName": "jvmHeapMaxBytesMax",
            "type": "number",
            "format": ""
        },
        {
            "name": "lastCheckpointDurationMs",
            "baseName": "lastCheckpointDurationMs",
            "type": "number",
            "format": ""
        },
        {
            "name": "lastCheckpointSizeBytes",
            "baseName": "lastCheckpointSizeBytes",
            "type": "number",
            "format": ""
        },
        {
            "name": "failedCheckpointsTotal",
            "baseName": "failedCheckpointsTotal",
            "type": "number",
            "format": ""
        },
        {
            "name": "restartsTotal",
            "baseName": "restartsTotal",
            "type": "number",
            "format": ""
        },
        {
            "name": "backpressureMaxRatio",
            "baseName": "backpressureMaxRatio",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return IngestionPipelineMetrics.attributeTypeMap;
    }
    constructor() {
    }
}
